/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 8a727ebdd3804d635229dbcaca01b85d7f53aadb4321ddfc419b8690ce600ff0
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './NavFooter.style'

export const NavFooterCompositionDependencies = ['NavItem', 'Pill'] as const

type NavFooterOwnProps = {
  className?: string
  minimized?: boolean
  tier?: 'starter' | 'pro' | 'enterprise'
}

export type NavFooterProps = NavFooterOwnProps & Omit<ComponentProps<'div'>, keyof NavFooterOwnProps>

function NavFooter(props: NavFooterProps): ReactElement {
  const {
    children,
    className = '',
    minimized = false,
    tier = 'starter',
    ...rest
  } = props

  return (
    <div
      className={cn('NavFooter', className, tier, { minimized, 'not-minimized': !minimized })}
      css={style}
      {...rest}
      role='navigation'
    >
      {children}
    </div>
  )
}

export default NavFooter
